
const tooglesCookie = document.querySelectorAll('[data-lang-toggle]');  
function writeCookie(name, val, expires) {
  var date = new Date;
  date.setDate(date.getDate() + expires);
  document.cookie = name+"="+val+"; domain=.omnio.site; path=/; SameSite=None; Secure; expires=" + date.toUTCString();
}

tooglesCookie.forEach((toggleCookie) => {
  toggleCookie.addEventListener('click', function(e){
    writeCookie('lang', toggleCookie.id, 7);
  });
});
